/* ------------------------------------------------------------------
   Color swatch hover preview (added Sep 21, 2026)
   On product cards, hovering a color swatch (an <li data-img="..."> inside
   ul.check.color, rendered by snippets/product-item.liquid) swaps that
   card's main photo to the hovered color's own photo, instead of doing
   nothing / letting the unrelated "second image" hover cross-fade take
   over. Reverts to the card's original photo when the swatch list is left.
   Only has an effect where a color variant actually has its own uploaded
   photo (color_variant.featured_media) -- for products where every color
   shares one photo, data-img is empty and this does nothing, which is
   expected. Paired CSS override lives in layout/theme.liquid.
------------------------------------------------------------------ */
(function () {
	function getCard(swatchLi) {
		return swatchLi.closest('.product-card');
	}
	function getMainImg(card) {
		if (!card) return null;
		var fig = card.querySelector('figure');
		if (!fig) return null;
		return fig.querySelector('picture:first-of-type img') || fig.querySelector('img');
	}
	document.addEventListener('mouseover', function (e) {
		var li = e.target.closest && e.target.closest('.check.color li[data-img]');
		if (!li) return;
		var card = getCard(li);
		var img = getMainImg(card);
		if (!img) return;
		if (typeof img.dataset.originalSrc === 'undefined') {
			img.dataset.originalSrc = img.getAttribute('src') || '';
			img.dataset.originalSrcset = img.getAttribute('srcset') || '';
		}
		var newSrc = li.getAttribute('data-img');
		if (newSrc) {
			img.setAttribute('src', newSrc);
			img.removeAttribute('srcset');
			card.classList.add('color-swatch-active');
		}
	}, { passive: true });
	document.addEventListener('mouseout', function (e) {
		var li = e.target.closest && e.target.closest('.check.color li[data-img]');
		if (!li) return;
		var list = li.closest('.check.color');
		var related = e.relatedTarget;
		if (related && list && list.contains(related)) return;
		var card = getCard(li);
		var img = getMainImg(card);
		if (!img) return;
		if (typeof img.dataset.originalSrc !== 'undefined') {
			img.setAttribute('src', img.dataset.originalSrc);
			if (img.dataset.originalSrcset) {
				img.setAttribute('srcset', img.dataset.originalSrcset);
			} else {
				img.removeAttribute('srcset');
			}
		}
		if (card) card.classList.remove('color-swatch-active');
	}, { passive: true });
})();

/* ------------------------------------------------------------------
   Product-page style/variant scroll fix (added Oct 17, 2026)
   On desktop (static gallery), picking a style/variant makes the theme call
   scrollIntoView() on the anchor #section-product-N, N = the variant's photo
   position (1 = first photo). Each anchor actually sits just before photo N+1,
   so the gallery landed one photo too far down (e.g. Hamsa showed the photo
   after the Hamsa one). This redirects that scroll to anchor N-1, which sits
   right before photo N, and for N = 1 to the top of the gallery.
   Only affects scrollIntoView() calls on #section-product-N anchors inside the
   static desktop gallery; every other scrollIntoView call is untouched.
------------------------------------------------------------------ */
(function () {
	var nativeScrollIntoView = Element.prototype.scrollIntoView;
	Element.prototype.scrollIntoView = function () {
		try {
			var match = /^section-product-(\d+)$/.exec(this.id || '');
			var gallery = match && this.closest && this.closest('.l4pr.static');
			if (gallery) {
				var position = parseInt(match[1], 10);
				var target = position > 1 ? gallery.querySelector('#section-product-' + (position - 1)) : gallery;
				if (target) return nativeScrollIntoView.apply(target, arguments);
			}
		} catch (e) {}
		return nativeScrollIntoView.apply(this, arguments);
	};
})();
